// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__13iG6","content":"LayoutSettings_content__3k80V"};